import type * as React from 'react';
import { get } from '@Domain/Api';
import roleImpactedUsersFetched, {
	type RoleImpactedUsersFetchedAction,
} from '@Application/Users/Users/Actions/roleImpactedUsersFetched';
import roleImpactedUsersFetchFailed, {
	type RoleImpactedUsersFetchFailedAction,
} from '@Application/Users/Users/Actions/roleImpactedUsersFetchFailed';
import type { UsersListFetchedPayload } from '@Application/Users/Users/Actions/usersFetched';
import type FetchRoleImpactedUsers from '@Application/Users/Users/Queries/FetchRoleImpactedUsers';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = RoleImpactedUsersFetchedAction | RoleImpactedUsersFetchFailedAction;

/**
 * Preview-only read for the revoke-permission confirmation, kept on its own `type` and its own
 * `usersStore` location on purpose: a shared `USERS_FETCHED` dispatch here would overwrite the Users
 * screen's own list.
 */
export default (query: FetchRoleImpactedUsers) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<UsersListFetchedPayload>(
				`${parameters.api.host}/api/accounts/${query.accountId}/users?${query.queryParams.toString()}`,
			);

			const action = roleImpactedUsersFetched(payload, query.accountId, query.roleId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = roleImpactedUsersFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
